import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Page,
  Inner,
  Kicker,
  Title,
  Text,
  Divider,
  StatusLine,
  PrimaryBtn,
  GhostBtn,
} from "./ConfirmedUserErrorPageStyles";

export default function ConfirmedUserErrorPage() {
  return (
    <Page>
      <Inner>
        <Kicker>Ahava Cakes</Kicker>
        <Title>Eroare la confirmare</Title>
        <Text>
          Linkul de confirmare este invalid sau a expirat. Te rugăm să retrimiți
          linkul din pagina de login.
        </Text>

        <Divider />

        <StatusLine $tone="error">
          Confirmare eșuată <span aria-hidden>✕</span>
        </StatusLine>

        <div
          style={{
            marginTop: 18,
            display: "flex",
            gap: 10,
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Link to="/login">
            <PrimaryBtn>Mergi la login</PrimaryBtn>
          </Link>
          <Link to="/">
            <GhostBtn>Înapoi pe site</GhostBtn>
          </Link>
        </div>
      </Inner>
    </Page>
  );
}
